/* House of Trinity Baking Co. — theme behaviour.
   Catalog, prices and the bag all come from Shopify; this file only adds interaction. */
(() => {
  const HOT = (window.HOT = window.HOT || {});
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const esc = (t) => String(t ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const routes = HOT.routes || { root: "/", cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change", allProducts: "/collections/all" };
  const ICON = {
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11Z"/><circle cx="12" cy="10" r="2.4"/></svg>',
    cal: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="5.5" width="16" height="15" rx="3"/><path d="M4 10h16M8.5 3.5v4M15.5 3.5v4M12 13v4M10 15h4"/></svg>',
  };

  /* ---------- Money ---------- */
  function money(cents) {
    const holder = document.createElement("div");
    holder.innerHTML = HOT.moneyFormat || "${{amount}}";
    const format = holder.textContent;
    const amount = (cents / 100).toFixed(2);
    const out = format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      if (key === "amount_no_decimals" || key === "amount_no_decimals_with_comma_separator") return String(Math.round(cents / 100));
      if (key === "amount_with_comma_separator") return amount.replace(".", ",");
      return amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    });
    return out.replace(/[.,]00(?!\d)/, "");
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const t = $("#toast"); if (!t) return;
    t.textContent = msg; t.classList.add("is-open");
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove("is-open"), 3200);
  }

  /* ---------- Header, mobile menu ---------- */
  function initChrome() {
    const nav = $("#nav");
    if (nav) {
      const onScroll = () => nav.classList.toggle("is-stuck", window.scrollY > 40);
      addEventListener("scroll", onScroll, { passive: true }); onScroll();
    }
    const burger = $("#burger"), menu = $("#mobile-menu");
    const setMenu = (open) => {
      if (!burger || !menu) return;
      menu.classList.toggle("is-open", open); menu.setAttribute("aria-hidden", !open); burger.setAttribute("aria-expanded", open);
      $("[data-burger-open]", burger).hidden = open; $("[data-burger-close]", burger).hidden = !open;
      document.body.style.overflow = open ? "hidden" : "";
    };
    burger?.addEventListener("click", () => setMenu(!menu.classList.contains("is-open")));
    $$("a", menu || document.createElement("div")).forEach((a) => a.addEventListener("click", () => setMenu(false)));
    addEventListener("keydown", (e) => { if (e.key === "Escape") { setBag(false); setMenu(false); } });
  }

  /* ---------- Bag (Shopify Ajax Cart API) ---------- */
  const json = (url, options) => fetch(url, { headers: { "Content-Type": "application/json", Accept: "application/json" }, ...options }).then(async (r) => {
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || "Something went wrong. Please try again.");
    return data;
  });
  let lastFocus;
  function setBag(open) {
    const drawer = $("#drawer"), scrim = $("#scrim"); if (!drawer) return;
    if (open) lastFocus = document.activeElement;
    drawer.classList.toggle("is-open", open); scrim.classList.toggle("is-open", open);
    drawer.setAttribute("aria-hidden", !open); document.body.style.overflow = open ? "hidden" : "";
    if (open) $("#bag-close")?.focus(); else lastFocus?.focus?.();
  }
  function renderBag(cart) {
    const badge = $("#bag-count");
    if (badge) { badge.textContent = cart.item_count; badge.classList.toggle("has-items", cart.item_count > 0); }
    const lines = $("#bag-lines"), foot = $("#bag-foot"); if (!lines) return;
    const s = HOT.strings || {};
    lines.innerHTML = cart.items.length ? cart.items.map((item) => {
      const picks = Object.entries(item.properties || {}).filter(([k, v]) => v && !k.startsWith("_")).map(([, v]) => v);
      const meta = [item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "", ...picks, item.selling_plan_allocation?.selling_plan?.name].filter(Boolean).join(" · ");
      const src = item.featured_image?.url || item.image || "";
      return `<div class="line" data-key="${esc(item.key)}">
        ${src ? `<img src="${esc(src)}${src.includes("?") ? "&" : "?"}width=200" alt="">` : "<span></span>"}
        <div><h3 class="h4"><a href="${esc(item.url)}">${esc(item.product_title)}</a></h3>${meta ? `<small>${esc(meta)}</small>` : "<small>&nbsp;</small>"}
          <div class="qty qty--sm"><button type="button" data-set-qty="${item.quantity - 1}" aria-label="Remove one">−</button><output>${item.quantity}</output><button type="button" data-set-qty="${item.quantity + 1}" aria-label="Add one">+</button></div></div>
        <span class="line__price">${money(item.final_line_price)}</span>
      </div>`;
    }).join("") : `<div class="drawer__empty"><img src="${esc(lines.dataset.emptyIcon || "")}" alt=""><h3 class="h3">${esc(s.emptyTitle)}</h3><p class="small" style="margin:10px 0 26px">${esc(s.emptyText)}</p><a class="btn btn--primary" href="${esc(routes.allProducts)}">${esc(s.emptyCta)}</a></div>`;

    foot.hidden = !cart.items.length; if (!cart.items.length) return;
    const min = (Number(HOT.freeDeliveryMin) || 0) * 100, left = Math.max(0, min - cart.total_price);
    const hasPlan = cart.items.some((i) => i.selling_plan_allocation);
    foot.innerHTML = `
      ${min ? `<p class="small">${left ? `Add <strong>${money(left)}</strong> more for free local delivery.` : "You’ve unlocked <strong>free local delivery</strong>."}</p><div class="meter"><i style="width:${Math.min(100, (cart.total_price / min) * 100)}%"></i></div>` : ""}
      <div class="drawer__total"><span>Subtotal</span><span>${money(cart.total_price)}</span></div>
      <p class="fine">${hasPlan ? "Bread Club memberships renew every 4 weeks. Skip, pause, or cancel anytime. Pick your first Thursday delivery date on the next step." : esc(s.bagNote || "")}</p>
      ${HOT.bagHandoff === "checkout"
        ? `<form action="${esc(routes.cart)}" method="post"><button class="btn btn--primary btn--block" type="submit" name="checkout">Check out</button></form>`
        : `<a class="btn btn--primary btn--block" href="${esc(routes.cart)}">${esc(s.bagCta || "Review your bag")}</a>`}`;
  }
  const refreshBag = () => json(routes.cart + ".js").then((cart) => (renderBag(cart), cart)).catch(() => {});
  async function addToBag(items, button) {
    const label = button?.textContent;
    try {
      if (button) { button.disabled = true; button.textContent = "Adding…"; }
      await json(routes.cartAdd + ".js", { method: "POST", body: JSON.stringify({ items }) });
      await refreshBag(); setBag(true);
    } catch (err) { toast(err.message); }
    finally { if (button) { button.disabled = false; button.textContent = label; } }
  }
  function initBag() {
    $("#bag-open")?.addEventListener("click", (e) => { e.preventDefault(); setBag(true); });
    $("#bag-close")?.addEventListener("click", () => setBag(false));
    $("#scrim")?.addEventListener("click", () => setBag(false));
    $("#bag-lines")?.addEventListener("click", async (e) => {
      const b = e.target.closest("[data-set-qty]"); if (!b) return;
      const line = b.closest(".line"); line.style.opacity = 0.5;
      try { renderBag(await json(routes.cartChange + ".js", { method: "POST", body: JSON.stringify({ id: line.dataset.key, quantity: Number(b.dataset.setQty) }) })); }
      catch (err) { toast(err.message); line.style.opacity = ""; }
    });
    // Quick add (cards, Bread Club plans)
    document.addEventListener("click", (e) => {
      const b = e.target.closest("[data-add]"); if (!b || b.disabled) return;
      const item = { id: Number(b.dataset.add), quantity: 1 };
      if (b.dataset.plan) item.selling_plan = Number(b.dataset.plan);
      addToBag([item], b);
    });
    refreshBag();
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.addEventListener("click", (e) => {
      const b = e.target.closest("[data-qty] [data-d]"); if (!b) return;
      const box = b.closest("[data-qty]"), input = $("input", box);
      const min = Number(input.min || 0), max = Number(input.max || 99);
      input.value = Math.max(min, Math.min(max, Number(input.value || 0) + Number(b.dataset.d)));
      if (box.hasAttribute("data-submit")) input.form.submit();
    });
    $$("[data-qty][data-submit] input").forEach((i) => i.addEventListener("change", () => i.form.submit()));
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    const form = $("[data-product-form]"); if (!form) return;
    const data = $("[data-variants]", form), variants = data ? JSON.parse(data.textContent) : null;
    const button = $("#pdp-add"), price = $("#pdp-price"), idInput = $('input[name="id"]', form);
    if (variants) form.addEventListener("change", (e) => {
      if (!e.target.matches("[data-option]")) return;
      const picked = $$("[data-option]:checked", form).sort((a, b) => a.dataset.option - b.dataset.option).map((i) => i.value);
      const v = variants.find((x) => x.options.every((o, i) => o === picked[i]));
      if (!v) { button.disabled = true; button.textContent = "Unavailable"; return; }
      idInput.value = v.id; price.textContent = money(v.price);
      button.disabled = !v.available; button.textContent = v.available ? "Add to bag" : "Sold out";
      const url = new URL(location.href); url.searchParams.set("variant", v.id); history.replaceState(null, "", url);
      if (v.featured_media?.id) $(`.pdp__thumb[data-media-id="${v.featured_media.id}"]`)?.click();
    });
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const fd = new FormData(form), item = { id: Number(fd.get("id")), quantity: Number(fd.get("quantity") || 1) };
      if (fd.get("selling_plan")) item.selling_plan = Number(fd.get("selling_plan"));
      const props = {}; for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
      if (Object.keys(props).length) item.properties = props;
      addToBag([item], button);
    });
    $$(".pdp__thumb").forEach((t) => t.addEventListener("click", () => {
      const img = $("#pdp-img img"); if (!img) return;
      img.removeAttribute("srcset"); img.src = t.dataset.full;
      $$(".pdp__thumb").forEach((x) => x.classList.toggle("is-current", x === t));
    }));
  }

  /* ---------- Motion ---------- */
  function observeReveals() {
    if (!("IntersectionObserver" in window)) return document.documentElement.classList.add("reveal-off");
    const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } }), { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
    $$(".reveal:not(.is-in)").forEach((el) => io.observe(el));
  }
  function litStatement() {
    $$(".statement").forEach((el) => {
      const walk = (node) => [...node.childNodes].forEach((n) => {
        if (n.nodeType === 3) { const f = document.createDocumentFragment(); n.textContent.split(/(\s+)/).forEach((t) => { if (!t.trim()) return f.append(t); const s = document.createElement("span"); s.className = "w"; s.textContent = t; f.append(s); }); n.replaceWith(f); }
        else walk(n);
      });
      walk(el);
      const words = $$(".w", el);
      const update = () => {
        const r = el.getBoundingClientRect(), vh = innerHeight;
        const prog = Math.min(1, Math.max(0, (vh * 0.88 - r.top) / (r.height + vh * 0.42)));
        const lit = Math.round(prog * words.length);
        words.forEach((w, i) => w.classList.toggle("is-lit", i < lit));
      };
      addEventListener("scroll", update, { passive: true }); addEventListener("resize", update); update();
    });
  }
  function heroParallax() {
    const main = $(".hero__img--main"), sides = $$(".hero__img--side");
    if (!main || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const update = () => { const y = Math.min(scrollY, 900); main.style.transform = `translateY(${y * -0.03}px) scale(${1 + y * 0.00012})`; sides.forEach((s) => (s.style.transform = `translateY(${y * -0.11}px)`)); };
    addEventListener("scroll", update, { passive: true }); update();
  }
  function rails() {
    $$("[data-rail]").forEach((ctrl) => {
      const rail = document.getElementById(ctrl.dataset.rail), [prev, next] = $$("button", ctrl); if (!rail || !prev || !next) return;
      const step = () => (rail.firstElementChild?.getBoundingClientRect().width || 320) + 20;
      prev.addEventListener("click", () => rail.scrollBy({ left: -step(), behavior: "smooth" }));
      next.addEventListener("click", () => rail.scrollBy({ left: step(), behavior: "smooth" }));
      const sync = () => { prev.disabled = rail.scrollLeft < 8; next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 8; };
      rail.addEventListener("scroll", sync, { passive: true }); addEventListener("resize", sync); sync();
    });
  }
  function hashtags() {
    $$("[data-hashtags]:not([data-done])").forEach((el) => { el.dataset.done = "1"; el.innerHTML = el.innerHTML.replace(/#[\w]+/g, (h) => `<span class="ig-tag">${h}</span>`); });
  }

  /* ---------- Markets: running schedule ---------- */
  const DOW = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const NTH = ["", "First", "Second", "Third", "Fourth", "Fifth"];
  const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const at = (d, hm) => { const [h, m] = String(hm || "0:00").split(":").map(Number); const x = new Date(d); x.setHours(h || 0, m || 0, 0, 0); return x; };
  const clock = (hm) => { const [h, m] = String(hm || "0:00").split(":").map(Number); return `${((h + 11) % 12) + 1}${m ? ":" + String(m).padStart(2, "0") : ""} ${h < 12 ? "AM" : "PM"}`; };
  const dayNumber = (d) => Math.round(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 864e5);   // DST-safe day index
  const nths = (m) => { const l = (m.rule.nths || []).map(Number).filter((n) => n >= 1 && n <= 5); return l.length ? l : [Number(m.rule.nth)]; };   // monthly: one or several weeks of the month
  const cadence = (m) => (m.rule.every === "week" ? `Every ${DOW[m.rule.dow]}` : m.rule.every === "2weeks" ? `Every other ${DOW[m.rule.dow]}` : `${nths(m).map((n) => NTH[n]).join(" & ")} ${DOW[m.rule.dow]} of the month`);
  const mapsUrl = (m) => `https://maps.apple.com/?q=${encodeURIComponent(m.name)}&address=${encodeURIComponent(m.address)}`;
  function runsOn(m, day) {
    if (Number(m.rule.dow) !== day.getDay() || (m.skip || []).includes(iso(day))) return false;
    if (m.rule.every === "2weeks") {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(m.rule.anchor || "")) return true;          // no anchor yet: show every week rather than nothing
      return (((dayNumber(day) - dayNumber(new Date(m.rule.anchor + "T00:00"))) % 14) + 14) % 14 === 0;
    }
    return m.rule.every === "week" || nths(m).includes(Math.ceil(day.getDate() / 7));
  }
  function occurrences(data, weeks, now = new Date()) {
    const out = [], day = new Date(now); day.setHours(0, 0, 0, 0);
    for (let i = 0; i < weeks * 7; i++, day.setDate(day.getDate() + 1)) {
      const key = iso(day);
      [...data.markets.filter((m) => runsOn(m, day)), ...(data.popups || []).filter((p) => p.date === key)].forEach((m) => {
        const start = at(day, m.start), end = at(day, m.end); if (end <= now) return;
        const cutoff = at(day, "00:00"); cutoff.setDate(cutoff.getDate() - data.cutoff.daysBefore); cutoff.setHours(data.cutoff.hour);
        out.push({ m, date: new Date(day), start, end, cutoff, live: start <= now, open: now < cutoff, days: Math.round((at(day, "00:00") - at(now, "00:00")) / 864e5) });
      });
    }
    return out.sort((a, b) => a.start - b.start);
  }
  const whenLabel = (o) => (o.live ? "Happening now" : o.days === 0 ? "Today" : o.days === 1 ? "Tomorrow" : o.days < 7 ? `This ${DOW[o.date.getDay()]}` : o.days < 14 ? `Next ${DOW[o.date.getDay()]}` : `In ${o.days} days`);
  const fmt = (d, o) => d.toLocaleDateString("en-US", o);
  function downloadIcs(o) {
    const stamp = (d) => `${iso(d).replace(/-/g, "")}T${String(d.getHours()).padStart(2, "0")}${String(d.getMinutes()).padStart(2, "0")}00`;
    const ics = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//House of Trinity Baking Co.//Markets//EN", "BEGIN:VEVENT", `UID:${o.m.id}-${iso(o.date)}@${location.hostname}`,
      `DTSTAMP:${stamp(new Date())}`, `DTSTART:${stamp(o.start)}`, `DTEND:${stamp(o.end)}`, `SUMMARY:House of Trinity Baking Co. at ${o.m.name}`, `LOCATION:${String(o.m.address).replace(/,/g, "\\,")}`,
      `DESCRIPTION:Fresh sourdough\\, bagels\\, and cinnamon rolls. Pre-order at ${location.hostname} for booth pickup.`, "END:VEVENT", "END:VCALENDAR"].join("\r\n");
    const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(new Blob([ics], { type: "text/calendar" })), download: `house-of-trinity-${iso(o.date)}.ics` });
    document.body.append(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    toast("Calendar file saved. See you at the booth.");
  }
  function initMarkets() {
    const src = $("#markets-data"); if (!src) return;
    const data = JSON.parse(src.textContent); let weeks = data.weeks || 8, area = "all";
    const orderLine = (o) => (o.live ? "Walk up, we’re here" : o.open ? `Pre-order by ${fmt(o.cutoff, { weekday: "short" })} ${clock(`${data.cutoff.hour}:00`)}` : "Pre-orders closed · walk-up welcome");
    const shop = esc(routes.allProducts);

    function renderNext(all) {
      const o = all[0], box = $("#next-market"); if (!o) return (box.innerHTML = "");
      const also = all.filter((x) => x !== o && iso(x.date) === iso(o.date));
      box.innerHTML = `<article class="tile tile--wide tile--split tile--dark next reveal">
        <div class="tile__copy">
          <span class="eyebrow">${o.live ? '<i class="dot"></i>' : ""}Next market · ${whenLabel(o)}</span>
          <h2 class="h2">${esc(o.m.name)}</h2>
          <dl class="next__facts">
            <div><dt>When</dt><dd>${fmt(o.date, { weekday: "long", month: "short", day: "numeric" })}<br>${clock(o.m.start)} – ${clock(o.m.end)}</dd></div>
            <div><dt>Where</dt><dd>${esc(o.m.spot)}<br>${esc(String(o.m.address).split(",").slice(0, 2).join(","))}</dd></div>
          </dl>
          <div class="cta-row">${o.open ? `<a class="btn btn--light" href="${shop}">Pre-order for pickup</a>` : ""}<a class="link link--light" href="${mapsUrl(o.m)}" rel="noopener" target="_blank">Get directions</a><button class="link link--light" type="button" data-ics="0">Add to calendar</button></div>
          <p class="fine next__note">${orderLine(o)}${o.open ? ". We’ll have it packed and waiting at the booth." : "."}${also.length ? `<br>Also that day: ${also.map((x) => `${esc(x.m.name)}, ${clock(x.m.start)} – ${clock(x.m.end)}`).join(" · ")}.` : ""}</p>
        </div>
        <div class="tile__media">${data.photo ? `<img src="${esc(data.photo)}${data.photo.includes("?") ? "&" : "?"}width=1400" alt="">` : ""}<div class="next__date"><span>${fmt(o.date, { month: "short" })}</span><b>${o.date.getDate()}</b><span>${fmt(o.date, { weekday: "short" })}</span></div></div>
      </article>`;
    }
    function renderSchedule(all) {
      const list = all.filter((o) => area === "all" || o.m.area === area); let month = "";
      $("#schedule").innerHTML = list.length ? list.map((o) => {
        const label = fmt(o.date, { month: "long" }), head = label !== month ? `<h3 class="month">${(month = label)} <small>${o.date.getFullYear()}</small></h3>` : "";
        return `${head}<div class="mrow reveal${o.live ? " is-now" : ""}">
          <div class="datebox"><span>${fmt(o.date, { weekday: "short" })}</span><b>${o.date.getDate()}</b></div>
          <div class="mrow__main"><h4 class="h4">${esc(o.m.name)}${o.m.special ? ' <span class="pill pill--tan">Pop-up</span>' : ""}</h4><p class="small">${esc(o.m.spot)} · ${esc(o.m.area)}</p></div>
          <div class="mrow__time"><strong>${clock(o.m.start)} – ${clock(o.m.end)}</strong><span class="pill ${o.live ? "pill--now" : o.open ? "" : "pill--muted"}">${o.live ? "Happening now" : o.open ? orderLine(o) : "Walk-up only"}</span></div>
          <div class="mrow__actions"><a class="icon-btn" href="${mapsUrl(o.m)}" target="_blank" rel="noopener" aria-label="Directions to ${esc(o.m.name)}">${ICON.pin}</a><button class="icon-btn" type="button" data-ics="${all.indexOf(o)}" aria-label="Add ${esc(o.m.name)}, ${fmt(o.date, { month: "long", day: "numeric" })} to calendar">${ICON.cal}</button>${o.open ? `<a class="btn btn--sm btn--ghost" href="${shop}">Pre-order</a>` : ""}</div>
        </div>`;
      }).join("") : `<p class="lede center" style="padding:64px 0">No markets in ${esc(area)} in the next ${weeks} weeks. We still deliver there, free.</p>`;
      $("#sched-range").textContent = `Next ${weeks} weeks · updates itself daily`;
      $("#more-weeks").hidden = weeks >= 24;
    }
    let current = [];
    function render() { current = occurrences(data, weeks); renderNext(current); renderSchedule(current); observeReveals(); }
    $("#markets-main").addEventListener("click", (e) => { const b = e.target.closest("[data-ics]"); if (b) downloadIcs(current[Number(b.dataset.ics)]); });

    const areas = ["all", ...new Set([...data.markets, ...(data.popups || [])].map((m) => m.area).filter(Boolean))];
    $("#area-chips").innerHTML = areas.map((a) => `<button class="chip" type="button" data-area="${esc(a)}" aria-pressed="${a === area}">${a === "all" ? "All markets" : esc(a)}</button>`).join("");
    $("#area-chips").addEventListener("click", (e) => { const c = e.target.closest(".chip"); if (!c) return; area = c.dataset.area; $$(".chip", $("#area-chips")).forEach((x) => x.setAttribute("aria-pressed", x === c)); renderSchedule(current); observeReveals(); });
    $("#more-weeks").addEventListener("click", () => { weeks += 8; render(); });
    const locs = $("#locs"); locs.dataset.n = data.markets.length;
    locs.innerHTML = data.markets.map((m, i) => `<div class="loc reveal" style="--d:${i * 0.06}s"><span class="eyebrow">${esc(m.area)}</span><h3 class="h3">${esc(m.name)}</h3>
      <p class="loc__when">${cadence(m)}<br>${clock(m.start)} – ${clock(m.end)}</p><p class="small">${esc(m.spot)}<br>${esc(m.address)}</p><a class="link" href="${mapsUrl(m)}" target="_blank" rel="noopener">Directions</a></div>`).join("");
    render(); setInterval(render, 5 * 60 * 1000);
  }
  // Contact page: borrow the schedule from the Markets page so "next market" is never typed twice.
  async function initNextMarketCard() {
    const box = $("#contact-next"); if (!box?.dataset.marketsUrl) return;
    try {
      const html = await fetch(box.dataset.marketsUrl).then((r) => r.text());
      const src = new DOMParser().parseFromString(html, "text/html").getElementById("markets-data"); if (!src) return;
      const next = occurrences(JSON.parse(src.textContent), 4)[0]; if (!next) return;
      box.innerHTML = `<a class="mini-market" href="${esc(box.dataset.marketsUrl)}"><span class="eyebrow">Or come see us · ${whenLabel(next)}</span><strong>${esc(next.m.name)}</strong>
        <p>${fmt(next.date, { weekday: "long", month: "long", day: "numeric" })}, ${clock(next.m.start)} – ${clock(next.m.end)}<br>${esc(next.m.spot)}, ${esc(next.m.area)}</p><span class="link link--light">All markets</span></a>`;
    } catch { /* the card is a nicety; the page works without it */ }
  }

  /* ---------- Forms ---------- */
  function wireValidation(form) {
    const fields = () => $$("input, textarea", form).filter((i) => i.closest(".f") && !i.closest("[hidden]"));
    const check = (i) => { const bad = !i.checkValidity(); i.closest(".f").classList.toggle("is-invalid", bad); i.setAttribute("aria-invalid", bad); return !bad; };
    form.addEventListener("focusout", (e) => { if (e.target.closest?.(".f") && e.target.value) check(e.target); });
    form.addEventListener("input", (e) => { if (e.target.closest?.(".f.is-invalid")) check(e.target); });
    form.addEventListener("submit", (e) => { const bad = fields().filter((i) => !check(i)); if (bad.length) { e.preventDefault(); bad[0].focus(); } });   // valid forms post to Shopify as normal
  }
  function initForms() {
    $$("[data-focus]").forEach((el) => { el.focus({ preventScroll: true }); el.scrollIntoView({ block: "center" }); });
    const contact = $("#contact-form");
    if (contact && !$("#contact-done")) {
      wireValidation(contact);
      contact.addEventListener("change", (e) => { const hint = $("#party-hint"); if (hint && e.target.name === "contact[Topic]") hint.hidden = !e.target.hasAttribute("data-party"); });
    }
    const party = $("#party-form");
    if (party && !$("#party-done")) {
      wireValidation(party);
      const date = $("#p-date"), note = $("#p-date-note"), addr = $("#p-address");
      const plus = (n) => { const d = new Date(); d.setHours(0, 0, 0, 0); d.setDate(d.getDate() + n); return d; };
      const notice = Number(date.dataset.noticeDays || 7), large = Number(date.dataset.largeDays || 14);
      date.min = iso(plus(notice));
      date.addEventListener("input", () => {
        const picked = date.value ? new Date(date.value + "T00:00") : null, ok = picked && picked >= plus(notice);
        note.hidden = !ok; if (!ok) return;
        note.textContent = picked < plus(large) ? "Heads up: orders over five dozen need two weeks’ notice. Smaller orders are fine for this date."
          : picked < plus(30) ? "That works for orders of any size. We’ll confirm availability within a few hours."
          : "Plenty of time. Booking this early is the best way to secure your date.";
      });
      party.addEventListener("change", (e) => {
        if (e.target.name !== "contact[Pickup or delivery]") return;
        const delivery = e.target.hasAttribute("data-delivery"); addr.hidden = !delivery;
        $$("[data-required-for-delivery]", addr).forEach((i) => (i.required = delivery));
        if (!delivery) $$(".is-invalid", addr).forEach((f) => f.classList.remove("is-invalid"));
      });
    }
  }

  /* ---------- FAQ page ---------- */
  function initFaq() {
    const input = $("#faq-q"); if (!input) return;
    const clear = $("#faq-clear"), status = $("#faq-status"), empty = $("#faq-empty"), side = $(".faq__side");
    const groups = $$("[data-group]");
    $("#faq-topics").innerHTML = groups.filter((g) => $("h2", g)).map((g) => `<li><a href="#${g.id}" data-spy="${g.id}">${esc($("h2", g).textContent)}<span>${$$("[data-q]", g).length}</span></a></li>`).join("");
    const items = $$("[data-q]").map((el) => ({ el, q: $("summary", el), text: el.textContent.toLowerCase(), label: $("summary", el).textContent }));
    const rx = (t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    function filter() {
      const raw = input.value.trim(), term = raw.toLowerCase(); let shown = 0;
      items.forEach((it) => {
        const hit = !term || it.text.includes(term); it.el.hidden = !hit; if (hit) shown++;
        it.q.innerHTML = term && hit ? esc(it.label).replace(new RegExp(`(${rx(esc(raw))})`, "ig"), "<mark>$1</mark>") : esc(it.label);
        if (term) it.el.open = hit && shown <= 3;
      });
      groups.forEach((g) => (g.hidden = !$$("[data-q]", g).some((d) => !d.hidden)));
      clear.hidden = !term; empty.hidden = shown > 0; $("#faq-term").textContent = raw; side.style.visibility = term ? "hidden" : "";
      status.textContent = term ? `${shown} ${shown === 1 ? "answer" : "answers"} for “${raw}”` : "";
      if (!term) items.forEach((it) => (it.el.open = false));
    }
    input.addEventListener("input", filter);
    clear.addEventListener("click", () => { input.value = ""; filter(); input.focus(); });
    const openFromHash = () => { const t = location.hash ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null; if (t?.matches("[data-q]")) { t.open = true; t.scrollIntoView({ block: "start" }); } };
    addEventListener("hashchange", openFromHash); openFromHash();
    if ("IntersectionObserver" in window) {
      const spy = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) $$("[data-spy]").forEach((a) => a.setAttribute("aria-current", a.dataset.spy === e.target.id)); }), { rootMargin: "-25% 0px -60% 0px" });
      groups.forEach((g) => spy.observe(g));
    }
  }

  /* ---------- Bread Club ---------- */
  function initClub() {
    const club = HOT.club || {};
    $$("[data-spots]").forEach((el) => (el.textContent = club.spots));
    const waitlist = $("[data-club-waitlist]");
    if (!club.full) {
      const meter = $("#founding-meter");
      if (meter && Number.isFinite(club.left)) meter.innerHTML = `<div class="founding-meter reveal"><div class="meter"><i style="width:${Math.max(0, Math.min(100, ((club.spots - club.left) / club.spots) * 100))}%"></i></div><p>${club.left} of ${club.spots} founding spots left</p></div>`;
      return;
    }
    const target = waitlist ? `#${waitlist.id}` : "#";
    if (waitlist) waitlist.hidden = false;
    const set = (key, fn) => $$(`[data-club="${key}"]`).forEach(fn);
    set("eyebrow", (el) => (el.textContent = "The Bread Club is full · Waitlist open"));
    set("cta", (el) => { el.textContent = "Join the waitlist"; el.href = target; });
    set("badge", (el) => (el.innerHTML = `<strong>${club.spots}</strong><span>founding spots, all taken.<br>Join the waitlist for the next opening.</span>`));
    set("founding-eyebrow", (el) => (el.textContent = "Thank you, Jacksonville"));
    set("founding-title", (el) => (el.textContent = "We’re full."));
    set("founding-copy", (el) => (el.innerHTML = `<p>All ${club.spots} founding Bread Club spots are gone. We’re a little overwhelmed and a lot grateful. The waitlist is open, and you’ll be the first to know when a spot opens up.</p>`));
    $$("[data-club-join]").forEach((b) => { const a = document.createElement("a"); a.className = b.className; a.href = target; a.textContent = "Join the waitlist"; b.replaceWith(a); });
  }

  /* ---------- Boot ---------- */
  const safely = (name, fn) => { try { fn(); } catch (err) { console.error(`[hot] ${name} failed`, err); } };   // one broken feature must never blank the page
  function boot() {
    [["chrome", initChrome], ["bag", initBag], ["qty", initQty], ["product", initProduct], ["markets", initMarkets], ["forms", initForms], ["faq", initFaq], ["club", initClub],
     ["hashtags", hashtags], ["statement", litStatement], ["parallax", heroParallax], ["rails", rails], ["reveals", observeReveals]].forEach(([n, f]) => safely(n, f));
    initNextMarketCard();
    HOT.ready = true;
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", boot) : boot();
  // Theme editor: re-run when a section is added or re-rendered.
  document.addEventListener("shopify:section:load", () => { safely("rails", rails); safely("hashtags", hashtags); safely("club", initClub); safely("reveals", observeReveals); });
})();
